import axios from "axios";

const configJson = require("../config.json");
const APIBASE = new URL(configJson.apiBase);
const APIURL = APIBASE + "api/baskets";

/**
 * Request for the baskets of the current user.
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export default async function basketRequest() {
  return await axios.get(APIURL, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("Bearer")
    }
  });
}
